import React from "react";
import PropTypes from "prop-types";
import qs from "query-string";
import InfinteScroll from "./InfiniteScroll";
import YaMetrika from "./YaMetrika";
import CoreContext from "../utils/context";
import SmiWebpush from "./Webpush";


export default class Core extends React.Component {
    constructor(props) {
        super(props);

        const context = {
            screen: props.screenProvider.detectScreen(),
            onBlockMount: this.onBlockMount,
            onTeaserClick: this.onTeaserClick,
            sid: null,
            rcid: null,
            fpr: null,
            fprVersion: null,
            queryString: qs.parse(window.location.search)
        };

        Object.assign(context, props.context || {});

        window.getSmiParams = () => {
            return {
                sid: context.sid
            }
        }

        this.state = {
            context,

            loading: false,
            data: {},

            scrollLoading: false,
            scrollData: [],

            lastLoadTeasers: [],

            scrollNum: 0,

            currency: {
                usd: 0,
                eur: 0
            }
        };
    }

    onBlockMount = props => {
        this.props.eventHandler.onBlockMount(this.state.context, props);
    };

    onTeaserClick = (props = {}) => {
        this.props.eventHandler.onTeaserClick(this.state.context, props);
    };

    onNewsClick = props => {
        const newProps = {};

        if (this.props.nextNews) {
            newProps.redirect = this.props.nextNews.preview_url;
        }

        this.props.eventHandler.onNewsClick(this.state.context, newProps);
    };

    onInternalClick = (props = {}) => {
        this.props.eventHandler.onInternalClick(this.state.context, props);
    };

    onRecommendationClick = (props = {}) => {
        this.props.eventHandler.onRecommendationClick(this.state.context, props);
    };

    onCategoryClick = props => {
        this.props.eventHandler.onCategoryClick(this.state.context, props);
    };

    onFirstLoad = () => {
        this.setState({ loading: true, data: {}, scrollData: [], scrollNum: 0 });

        this.props.dataProvider.loadInitialData(this.state.context).then(initialData => {
            const { data, scrollData = [], lastLoadTeasers = [] } = initialData;
            this.setState({ loading: false, data, scrollData, lastLoadTeasers });
        });

        this.props.dataProvider.loadCurrency().then(currency => this.setState({ currency }));
    };

    onScrollLoad = () => {
        if (this.state.scrollLoading) {
            return;
        }

        if (this.props.scrollLimit && this.state.scrollNum >= this.props.scrollLimit) {
            return;
        }

        this.setState({ scrollLoading: true });

        this.props.eventHandler.onScrollLoad(this.state.context, this.state.scrollNum);

        this.props.dataProvider.loadScrollData(this.state.context, this.state.scrollNum).then(result => {
            this.setState(prevState => {
                let { scrollData, lastLoadTeasers = [] } = result;
                scrollData = prevState.scrollData.concat(scrollData);

                return {
                    scrollLoading: false,
                    scrollNum: prevState.scrollNum + 1,
                    scrollData,
                    lastLoadTeasers
                };
            });
        });
    };

    handleResize = () => {
        const screen = this.props.screenProvider.detectScreen();
        if (this.state.context.screen != screen) {
            this.setState(prevState => {
                const context = Object.assign({}, this.state.context, { screen });
                return { context };
            });
        }
    };

    componentDidMount() {
        window.addEventListener("resize", () => {
            this.handleResize();
        });
        this.props.eventHandler.onCoreMount(this.state.context);
        this.onFirstLoad();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.context.screen != prevState.context.screen) {
            this.onFirstLoad();
        }
    }

    render() {
        return (
            <InfinteScroll onNextLoad={this.onScrollLoad}>
                <SmiWebpush />
                <YaMetrika id={45661026} />
                <CoreContext.Provider value={this.state.context}>
                    {this.props.children({
                        onBlockMount: this.onBlockMount,
                        onNewsClick: this.onNewsClick,
                        onTeaserClick: this.onTeaserClick,
                        onCategoryClick: this.onCategoryClick,
                        onInternalClick: this.onInternalClick,
                        onRecommendationClick: this.onRecommendationClick,

                        loading: this.state.loading,
                        scrollLoading: this.state.scrollLoading,

                        data: this.state.data,
                        scrollData: this.state.scrollData,
                        lastLoadTeasers: this.state.lastLoadTeasers,

                        news: this.props.news,
                        nextNews: this.props.nextNews,
                        categories: this.props.categories,

                        currency: this.state.currency,
                        geoCity: this.props.geoCity,
                        use_html_render: this.props.use_html_render,

                        context: this.state.context
                    })}
                </CoreContext.Provider>
            </InfinteScroll>
        );
    }
}

Core.propTypes = {
    dataProvider: PropTypes.object.isRequired,
    screenProvider: PropTypes.object.isRequired,
    eventHandler: PropTypes.object.isRequired,
    scrollLimit: PropTypes.number,
    children: PropTypes.func.isRequired
};

Core.defaultProps = {
    geoCity: "",
    scrollLimit: 0
};
